/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCountDto } from '../../models/contents-request-count-dto';

export interface ContentsRequestControllerGetCount$Params {
}

export function contentsRequestControllerGetCount(http: HttpClient, rootUrl: string, params?: ContentsRequestControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCountDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerGetCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestCountDto>;
    })
  );
}

contentsRequestControllerGetCount.PATH = '/api/contents-request/count';
